module.exports = __webpack_public_path__ + "static/button_google_play-fdf7e1c7565e3a70155ce9270692ccea.svg";